import { render } from "./LoaderFull.vue?vue&type=template&id=72b8d762"
import script from "./LoaderFull.vue?vue&type=script&lang=js"
export * from "./LoaderFull.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__